import { FtuxConfig, FtuxStep } from '../types';
import { ensureLastStepIsDone } from './utils';

export const getResourcesConfig = (): FtuxConfig => {
	const steps: FtuxStep[] = [
		{
			type: 'modal' as const,
			title: 'LLLL Resources Catalogue',
			subtitle:
				'You can find various Little Learners Love Literacy Resources in this area that can be used in activities and learning in and out of class.\n\nFind a resource that appears in your weekly plans and download it here.',
			image: '/img/ftux-resources-1.png',
			button: {
				label: 'Next',
				type: 'paginated' as const,
				hasBackButton: false
			},
			modalPosition: 'bottom-right' as const,
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#dropdown-title-section',
			subtitle: 'Quickly jump to the right resource by selecting the resource category.',
			tooltipPlacement: 'bottom' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#favourites-toggle',
			subtitle:
				'Save specific resources to your favourites and easily switch to view them.',
			tooltipPlacement: 'bottom' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#filter-input',
			subtitle: 'Search for a resource by typing the name of the resource here.',
			tooltipPlacement: 'bottom' as const, 
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		}
	];

	const config: FtuxConfig = {
		id: 'resources-ftux',
		name: 'Resources Tutorial',
		showSkipButton: false,
		steps
	};

	// Ensure the last step always has "Done" as the label
	return ensureLastStepIsDone(config);
};
